const HeaderData = [
  {
    title: "Home",
    link: "/",
  },
  {
    title: "Cases",
    link: "/cases"
  },
  {
    title: "File a Dispute",
    link:"/content/4"

  },
  {
    title: "File a Response",
    link:"/content/5"

  },
  {
    title: "Fees",
    link: "/content/17"
  },
  {
    title: "Resources",
    link: '/content/16'


  },
  {title: "Statistics",
    link: "/statistics"
  },
  {
    title: "News",
    link: "/news",
  },
  {title: "Other",
    link: "hello"
  },

  {
    title: "Login",
    link: "/userprofile"
  },
  {
    title: "More",
    dropdown: []
  }

];

export default HeaderData;
